import { Component } from '@angular/core'

@Component({
   selector: 'app-basic-spinner',
   templateUrl: './app-spinner.component.html',
   standalone: true
})
export class AppSpinnerComponent {}
